interface EnvironmentConfig {
  API_BASE_URL: string;
  WS_URL: string;
  API_TIMEOUT: number;
  GOOGLE_CLIENT_ID: string;
  APP_NAME: string;
  APP_VERSION: string;
  ENVIRONMENT: 'development' | 'staging' | 'production';
  ENABLE_ANALYTICS: boolean;
  ENABLE_ERROR_REPORTING: boolean;
  MAX_FILE_SIZE: number;
  ALLOWED_FILE_TYPES: string[];
}

function getEnvVar(key: string, defaultValue?: string): string {
  const value = import.meta.env[key];
  if (value === undefined) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error(`Environment variable ${key} is not defined`);
  }
  return value;
}

function getEnvBoolean(key: string, defaultValue = false): boolean {
  const value = import.meta.env[key];
  if (value === undefined) {
    return defaultValue;
  }
  return value === 'true' || value === '1';
}

function getEnvNumber(key: string, defaultValue?: number): number {
  const value = import.meta.env[key];
  if (value === undefined) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error(`Environment variable ${key} is not defined`);
  }
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    throw new Error(`Environment variable ${key} is not a valid number`);
  }
  return parsed;
}

export const env: EnvironmentConfig = {
  API_BASE_URL: getEnvVar('VITE_API_BASE_URL', 'http://localhost:8080'),
  WS_URL: getEnvVar('VITE_WS_URL', 'ws://localhost:8080/ws/conversations'),
  API_TIMEOUT: getEnvNumber('VITE_API_TIMEOUT', 60000), // 60 seconds for AI requests
  GOOGLE_CLIENT_ID: getEnvVar('VITE_GOOGLE_CLIENT_ID'),
  APP_NAME: getEnvVar('VITE_APP_NAME', 'Job Consultancy Platform'),
  APP_VERSION: getEnvVar('VITE_APP_VERSION', '1.0.0'),
  ENVIRONMENT: getEnvVar('VITE_ENVIRONMENT', 'development') as EnvironmentConfig['ENVIRONMENT'],
  ENABLE_ANALYTICS: getEnvBoolean('VITE_ENABLE_ANALYTICS'),
  ENABLE_ERROR_REPORTING: getEnvBoolean('VITE_ENABLE_ERROR_REPORTING'),
  MAX_FILE_SIZE: getEnvNumber('VITE_MAX_FILE_SIZE', 10485760), // 10MB
  ALLOWED_FILE_TYPES: getEnvVar(
    'VITE_ALLOWED_FILE_TYPES',
    'application/pdf,image/jpeg,image/png'
  ).split(','),
};

export const isDevelopment = env.ENVIRONMENT === 'development';
export const isProduction = env.ENVIRONMENT === 'production';
export const isStaging = env.ENVIRONMENT === 'staging';
